import FullWidthHeader from "@components/BasicComponents/FullWidthHeader/FullWidthHeader"
import Separator from "@components/CustomTypography/Separator/Separator"
import SocialResponsibilityContactFormSection from "@components/Pages/SocialResponsibility/SocialResponsibilityForm/SocialResponsibilityContactFormSection"
import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import getValueOrThrow from "@helpers/getValueOrError"
import {getTranslatedPageData} from "@hooks/PagesData/getTranslatedPageData"
import ExpertiseJson from "@jsons/expertise.json"
import ExpertiseIntro from "@pages/Expertise/ExpertiseIntro/ExpertiseIntro"
import ExpertiseWorkshop from "@pages/Expertise/ExpertiseWorkshop/ExpertiseWorkshop"
import React from "react"

type Props = {}

const expertise = (props: Props): JSX.Element => {
	const pageData = getTranslatedPageData(ExpertiseJson, true, true)
	const ExpertiseSections = getValueOrThrow(pageData.AdvancedSideAsset)
	const hero = getValueOrThrow(pageData.heroData?.[0])

	return (
		<>
			<HeadMeta
				meta={pageData.metaData}
				customPath={"/about-us/expertise"}
			/>

			<FullWidthHeader data={hero} position={"left"} size={"L"} />
			<ExpertiseIntro data={ExpertiseSections[0]} />

			<Separator size={128} />

			<ExpertiseWorkshop
				data={[ExpertiseSections[1], ExpertiseSections[2]]}
			/>

			<SocialResponsibilityContactFormSection />
		</>
	)
}

export default expertise
